import { logger } from '@main/core-ui';

/**
 * Build a safe, same-origin URL for internal redirects.
 * Rejects absolute external URLs and falls back to `/`.
 *
 * @param path - Relative path or query string (e.g. "/dashboard", "settings?tab=2")
 * @param origin - Expected origin (defaults to current origin)
 * @returns Safe path string (pathname + search + hash), or "/" if invalid
 */
export function safeUrl(path: string, origin = window.location.origin): string {
  try {
    const url = new URL(path, origin);

    if (url.origin !== origin) {
      logger.warn(`Blocked unsafe redirect to different origin: ${url.href}`);
      return '/';
    }

    return url.pathname + url.search + url.hash;
  } catch {
    logger.warn(`Blocked unsafe redirect to invalid URL: ${path}`);
    return '/';
  }
}
